import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Eye } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface UIContentSettingsSectionProps {
  settings: {
    showRecommendedSection: boolean;
  };
  updateSetting: (key: string, value: any) => void;
}

const UIContentSettingsSection = ({ settings, updateSetting }: UIContentSettingsSectionProps) => {
  const { t } = useLanguage();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Eye className="h-5 w-5" />
          {t('ui_content_settings', 'إعدادات الواجهة والمحتوى', 'UI & Content Settings')}
        </CardTitle>
        <CardDescription>
          {t('ui_content_description', 'تحكم في عناصر الواجهة والمحتوى المعروض للمستخدمين', 'Control interface elements and content displayed to users')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>{t('show_recommended_section', 'عرض قسم الموصى لك', 'Show Recommended Section')}</Label>
            <p className="text-sm text-muted-foreground">
              {t('show_recommended_section_desc', 
                'عرض قسم "الموصى لك" في الصفحة الرئيسية للمستخدمين المسجلين', 
                'Display the "Recommended For You" section on the homepage for logged-in users'
              )}
            </p>
          </div>
          <Switch
            checked={settings.showRecommendedSection}
            onCheckedChange={(checked) => updateSetting('showRecommendedSection', checked)}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default UIContentSettingsSection;